import { render } from "./NewCandidacy.vue?vue&type=template&id=dab3444a&scoped=true"
import script from "./NewCandidacy.vue?vue&type=script&lang=js"
export * from "./NewCandidacy.vue?vue&type=script&lang=js"

import "./NewCandidacy.vue?vue&type=style&index=0&id=dab3444a&scoped=true&lang=css"

import exportComponent from "/var/www/html/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab3444a"]])

export default __exports__